import { gql } from '@apollo/client';

export const REQUEST_PIN = gql`
  mutation RequestPin($channel: String!, $value: String!) {
    requestPin(channel: $channel, value: $value) {
      success
      credentialId
    }
  }
`;

export const SIGNUP = gql`
  mutation Signup(
    $fullName: String!
    $birthDate: String!
    $area: String!
    $email: String
    $phone: String
    $plan: String
    $preferences: JSON
    $legalAccepted: Boolean!
    $legalAcceptedAtIso: String!
  ) {
    signup(
      fullName: $fullName
      birthDate: $birthDate
      area: $area
      email: $email
      phone: $phone
      plan: $plan
      preferences: $preferences
      legalAccepted: $legalAccepted
      legalAcceptedAtIso: $legalAcceptedAtIso
    ) {
      success
      message
    }
  }
`;

export const VALIDATE_USER = gql`
  mutation ValidateUser($channel: String!, $value: String!, $code: String) {
    validateUser(channel: $channel, value: $value, code: $code) {
      success
      message
      status
      verified {
        email
        phone
      }
    }
  }
`;

export const LOGIN = gql`
  mutation Login($channel: String!, $value: String!, $code: String!) {
    login(channel: $channel, value: $value, code: $code) {
      token
      user {
        id
        email
        phone
        fullName
        status
        plan
        preferences
        verified {
          email
          phone
        }
      }
    }
  }
`;

export const VERIFY_CONTACT_CHANGE = gql`
  mutation VerifyContactChange($code: String!) {
    verifyContactChange(code: $code) {
      success
      message
    }
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation DeleteAccount($confirmation: String!) {
    deleteAccount(confirmation: $confirmation) {
      success
      message
    }
  }
`;

export const ME_QUERY = gql`
  query Me {
    me {
      id
      email
      phone
      fullName
      birthDate
      area
      plan
      status
      role
      preferences
      verified {
        email
        phone
      }
      whatsapp
      whatsappOptIn
      termsAcceptedVersion
      termsAcceptedAt
      termsAcceptedAtIso
      privacyAcceptedVersion
      privacyAcceptedAt
      privacyAcceptedAtIso
      plusEntitlementUntil
      plusLifetime
      proTrialUntil
      connectBetaPriority
      contributionCount
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($fullName: String, $birthDate: String, $area: String, $plan: String, $preferences: JSON) {
    updateUser(fullName: $fullName, birthDate: $birthDate, area: $area, plan: $plan, preferences: $preferences) {
      id
      fullName
      area
      plan
      preferences
    }
  }
`;
